import { createRoute, redirect } from "@tanstack/react-router";
import { ExtractPanel } from "@/components/extract-panel";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Spinner } from "@/components/ui/spinner";
import { rootRoute } from "./root-route";

export const extractRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/extract",
  beforeLoad: async () => {
    try {
      await api.me();
    } catch {
      throw redirect({
        to: "/login",
        search: { returnTo: "/extract", error: undefined },
      });
    }
  },
  component: ExtractPage,
});

function ExtractPage() {
  const auth = useAuth();

  if (auth.status === "loading") {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (auth.status === "anon") return null;

  return <ExtractPanel />;
}
